__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/67706639cdc2b709786ba524f74d48cee8d6fb381434e64dcd584068/";